//Сервис предназначен исключительно для облегчения работы других сервисов с редаксом.
//в осносном, на случай если мы захотим переместить к.л. переменную в другое расположение
//в этом случае (если остальные С. работают через этого посредника) нам достаточно будет
//поменять ф-цию получения переменной из редакса в этом посреднике.

export default class ReduxReaderService{
    constructor(store){
      if(!store){
        throw new Error("Required the redux-store")
      }
      this.store=store;
    }
  
    //Сервисы
    get service_Api(){
      return this._service.Api;
    }
    get service_User(){
      return this._service.User;
    }
    get service_Directory(){
      return this._service.Directory;
    }
    get service_Route(){
      return this._service.Route;
    }
    get service_Geozone(){
      return this._service.Geozone;
    }
  
    //АПИ
    get api_isInited(){
      return this._api.isInited;
    }
    /**Это только для загрузки данных по пользователю */
    get api_user(){
      return this._api.user;
    }
    get api_rights(){
      return this._api.rights;
    }

    get api_geoObjs(){
      return this._api.geoObjs;
    }

    get api_geoObjReport(){
      return this._api.geoObjReport;
    }

    get api_geoMultiObjReport(){
      return this._api.geoMultiObjReport;
    }

    get api_geoObjDashboard(){
      return this._api.geoObjDashboard;
    }

    get api_geoObjRoute(){
      return this._api.geoObjRoute;
    }

    get api_geoObjGeozone(){
      return this._api.geoObjGeozone;
    }

    get api_savingGeoObjGeozone(){
      return this._api.savingGeoObjGeozone;
    }

    get api_geoObjReportExcel(){
      return this._api.geoObjReportExcel;
    }

    get api_geoObjVisits(){
      return this._api.geoObjVisits;
    }

    get api_geoMultiObjReportExcel(){
      return this._api.geoMultiObjReportExcel;
    }

    get api_workingTimeSheet(){
      return this._api.workingTimeSheet;
    }

    get api_directoryList(){
      return this._api.directoryList;
    }

    get api_directoryData(){
      return this._api.directoryData;
    }

    get api_directoryShort(){
      return this._api.directoryShort;
    }

    get api_documentData(){
      return this._api.documentData;
    }

    get api_singleDocument(){
      return this._api.singleDocument;
    }

    get api_singleDocument2(){
      return this._api.singleDocument2;
    }

    get api_addingDocument(){
      return this._api.addingDocument;
    }

    get api_savingDocument(){
      return this._api.savingDocument;
    }

    get api_deletingDocument(){
      return this._api.deletingDocument;
    }

    get api_changingStatusDocument(){
      return this._api.changingStatusDocument;
    }

    get api_planWorkDir(){
      return this._api.planWorkDir;
    }

    get api_planScheduleStatuses(){
      return this._api.planScheduleStatuses;
    }

    get api_orderWorkStatuses(){
      return this._api.orderWorkStatuses;
    }

    get api_footerInfo(){
      return this._api.footerInfo;
    }



    //Веб Воркеры
    get ww_PBSectorInited(){
      return this._ww.PBSectorInited;
    }
  
  

    //Пользователь
    get user_user(){
      return this._user.user
    }
    
    get user_isLoggedIn(){
      return this._user.isLoggedIn
    }
    
    get user_settings(){
      return this._user.settings
    }
    
    get user_rights(){
      return this._user.rights
    }
    
    get user_rolename(){
      return this._user.rolename
    }

    //Справочники
    get directory_shorts(){
      return this._directory.shorts
    }
    get directory_loaded(){
      return this._directory.loaded
    }

    //Маршруты
    get route_routeArr(){
      return this._route.routeArr
    }
    get route_routeSettingsArr(){
      return this._route.routeSettingsArr
    }
    get route_paletteStatus(){
      return this._route.paletteStatus
    }

    //Геозоны
    get geozone_geozoneArr(){
      return this._geozone.geozoneArr
    }
    get geozone_geozoneSettingsArr(){
      return this._geozone.geozoneSettingsArr
    }
    get geozone_geozoneVertexArr(){
      return this._geozone.geozoneVertexArr
    }

    get geozone_geozoneIntersections(){
        return this._geozone.geozoneIntersections
    }

    get geozone_activitiByZone(){
        return this._geozone.activitiByZone
    }

  
  
    //Внутренние ф-ции
    get _state(){
      return this.store.getState();
    }
  
    get _service(){
      return this._state.service;
    }
    get _api(){
      return this._state.api;
    }
    get _ww(){
      return this._state.ww;
    }
    get _map(){
      return this._state.map;
    }
    get _ui(){
      return this._state.ui;
    }
    get _user(){
      return this._state.user;
    }
    get _directory(){
      return this._state.directory;
    }
    get _route(){
      return this._state.route;
    }
    get _geozone(){
      return this._state.geozone;
    }
    
  }